export function tenantLabel(tenant, key, fallback) {
  return tenant?.settings?.labels?.[key] ?? fallback;
}
